import React, { Component } from 'react';
import Firebase from 'firebase';
import { Dropdown, DropdownMenu, DropdownItem, Progress } from 'reactstrap';
import DatosGlobales from './datosGlobales'
import LastReg from './LastReg'
import GraficoRxT from './graficoRxT'
import GraficoUxT from './graficoUxT'
import Map from './map'


const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandDanger = '#f86c6b';

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chart: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: '# of Votes',
                            data: [],
                            fillColor: "rgba(254, 27, 34, 0.3)",
                            pointColor: "rgba(254, 27, 34, 0.3)",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: "rgba(254, 27, 34, 0.3)",
                            pointStrokeColor: "#fff",
                            strokeColor: "rgba(254, 27, 34, 0.3)",
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)'
                            ],
                            borderColor: [
                                'rgba(255,99,132,1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)'
                            ],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            },
            lat: 0,
            lon: 0
        };
        this.renderCharts = this.renderCharts.bind(this);
    }

    componentWillMount() {
        var formRef = Firebase.database().ref("forms");
        var dataRef = Firebase.database().ref("saved").child(localStorage.client_id);
        dataRef.on('value', snap => {
            var forms = [];
            Object.keys(snap.val()).map(form => {
                formRef.child(form).once('value').then(resp => {
                    forms.push({ value: form, name: resp.val().name })
                    this.setState({ listForms: forms })
                });
            })
            this.setState({ form: Object.keys(snap.val())[0] })
        });
    }

    renderCharts() {
        if (this.state.form) {
            return (
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="col-md-6">
                            <GraficoUxT formId={this.state.form} />
                        </div>
                        <div className="col-md-6">
                            <GraficoRxT formId={this.state.form} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <div className="col-md-8">
                            <LastReg formId={this.state.form} setGPS={(lat, lon) => { this.setState({ lat: lat, lon: lon }) }} />
                        </div>
                        <div className="col-md-4">
                            <Map lat={this.state.lat} lon={this.state.lon} />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="col-md-2" style={{ backgroundColor: "#263238", left: "-30px", top: "-22px", marginBottom: "-52px" }} >
                            <br />
                            <h3 style={{ color: "#FFF", borderBottom: "1px #FFF solid" }}>Formularios </h3>
                            <section className="section section--menu">
                                <span className="link-copy"></span>
                                <nav className="menu menu--ferdinand-graficas">
                                    {
                                        this.state.listForms
                                            ?
                                            this.state.listForms.map((list, index) => (
                                                <li key={index} className={this.state.form === list.value ? "menu__item menu__item--current" : "menu__item"} style={this.state.form !== list.value ? { color: "#CCC" } : {}}>
                                                    <a style={{ color: "#FFF" }} onClick={() => { this.setState({ form: list.value }) }} style={{ cursor: "pointer", textAlign: "left" }} className="menu__link">{list.name}</a>
                                                </li>
                                            ))
                                            :
                                            ""
                                    }
                                </nav>
                            </section>
                        </div>
                        <div className="col-md-10">
                            <DatosGlobales />
                            <br />
                            <div className="col-md-12">
                                <div className="form-group row">
                                    {this.renderCharts()}
                                </div>
                            </div>
                        </div>
                    </div >
                </div>
            </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashBoard/dashBoard.js